export default "__VITE_ASSET__e15a5d43__"